import React from 'react';
import LegalLayout from './LegalLayout';

const PrivacyPolicyPage: React.FC = () => (
  <LegalLayout title="Privacy Policy" lastUpdated="Nov 12 2025">
    <p>
      This privacy policy sets out how DRPINFOTECH PRIVATE LIMITED uses and protects any information that you
      give DRPINFOTECH PRIVATE LIMITED when you visit our website and/or agree to purchase from us.
    </p>
    <p>
      DRPINFOTECH PRIVATE LIMITED is committed to ensuring that your privacy is protected. Should we ask you to
      provide certain information by which you can be identified when using this website, you can be assured
      that it will only be used in accordance with this privacy statement.
    </p>
    <p>
      DRPINFOTECH PRIVATE LIMITED may change this policy from time to time by updating this page. You should
      check this page periodically to ensure that you are comfortable with any changes.
    </p>
    <h5 className="text-white mt-4">Information we may collect</h5>
    <ul className="legal-list">
      <li>Name</li>
      <li>Contact information including email address</li>
      <li>Demographic information such as postcode, preferences and interests (if required)</li>
      <li>Other information relevant to customer surveys and/or offers</li>
    </ul>
    <h5 className="text-white mt-4">How we use the information we gather</h5>
    <p>
      We require this information to understand your needs and provide you with a better service, and in
      particular for the following reasons:
    </p>
    <ul className="legal-list">
      <li>Internal record keeping.</li>
      <li>To improve our products and services.</li>
      <li>
        To periodically send promotional emails about new products, special offers or other information which we
        think you may find interesting using the email address which you have provided.
      </li>
      <li>
        To contact you for market research purposes from time to time via email, phone, fax or mail, and to
        customise the website according to your interests.
      </li>
    </ul>
    <p>
      We are committed to ensuring that your information is secure. In order to prevent unauthorised access or
      disclosure we have put in place suitable measures.
    </p>
    <h5 className="text-white mt-4">How we use cookies</h5>
    <p>
      A cookie is a small file which asks permission to be placed on your computer&apos;s hard drive. Once you
      agree, the file is added and the cookie helps analyse web traffic or lets you know when you visit a
      particular site. Cookies allow web applications to respond to you as an individual by tailoring operations
      to your needs, likes and dislikes.
    </p>
    <p>
      We use traffic log cookies to identify which pages are being used. This helps us analyse data about web
      page traffic and improve our website in order to tailor it to customer needs. We only use this information
      for statistical analysis purposes and then the data is removed from the system.
    </p>
    <p>
      Overall, cookies help us provide you with a better website by enabling us to monitor which pages you find
      useful and which you do not. A cookie in no way gives us access to your computer or any information about
      you, other than the data you choose to share with us.
    </p>
    <p>
      You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can
      usually modify your browser settings to decline cookies if you prefer. This may prevent you from taking
      full advantage of the website.
    </p>
    <h5 className="text-white mt-4">Controlling your personal information</h5>
    <ul className="legal-list">
      <li>
        Whenever you are asked to fill in a form on the website, look for the box you can click to indicate that
        you do not want the information to be used by anybody for direct marketing purposes.
      </li>
      <li>
        If you have previously agreed to us using your personal information for direct marketing purposes, you
        may change your mind at any time by writing to or emailing us at{' '}
        <a className="text-white" href="mailto:contact@drpinfotech.com">
          contact@drpinfotech.com
        </a>
        .
      </li>
    </ul>
    <p>
      We will not sell, distribute or lease your personal information to third parties unless we have your
      permission or are required by law to do so. We may use your personal information to send you promotional
      information about third parties which we think you may find interesting if you tell us that you wish this
      to happen.
    </p>
    <p>
      If you believe that any information we are holding on you is incorrect or incomplete, please write to TS
      Homes Ratnakar Bagh Tankapani Road Bhubaneswar Khorda Orissa 751014 India Bhubaneswar Court ODISHA 751014,
      or contact us at{' '}
      <a className="text-white" href="tel:+918249363019">
        8249363019
      </a>{' '}
      or{' '}
      <a className="text-white" href="mailto:contact@drpinfotech.com">
        contact@drpinfotech.com
      </a>{' '}
      as soon as possible. We will promptly correct any information found to be incorrect.
    </p>
  </LegalLayout>
);

export default PrivacyPolicyPage;

